import React, {useEffect, useState} from 'react';
import {FormControl} from 'react-bootstrap';
import {ConfirmationDialog} from "../../Common/ConfirmationDialog";
import {service as SurveyTypeService} from  "../../../Services/SurveyTypeService";

import {ConservationActionFieldEditor} from "../../../Models/Core/ServiceDrivenEditors";

export const CopyAnswersModal = props => {
    const {targetConservationActionId, targetConservationActionTypeId, targetSurveyTypeId, onHide} = props;
    const [surveyTypeId, setSurveyTypeId] = useState(targetSurveyTypeId);
    const [conservationActionId, setConservationActionId] = useState(targetConservationActionId);
    const [surveyTypes, setSurveyTypes] = useState([]);

    useEffect(() => {
        SurveyTypeService.Get().then((result) => {
            // Permits can't be copied from 'Permits' survey
            const surveysThatAreAllowedToBeCopied = (result.result ?? [])
                .filter(surveyType => surveyType.conservationActionPhaseId != null ); 
            setSurveyTypes(surveysThatAreAllowedToBeCopied);
        })
    }, []);
    
    return (
        <ConfirmationDialog
            Display={props.show}
            Title={`Copy Answers From Existing Survey`}
            OnConfirm={() => props.onConfirm(conservationActionId, surveyTypeId) }
            OnClose={onHide}
            ConfirmationButtonMessage={"Copy Answers"}
            CancelButtonMessage={"Cancel"}
            DisableConfirmationButton={!(surveyTypes && surveyTypeId && conservationActionId)}
        >
            <div key={1}>
                <p>Select a Conservation Action and Survey to copy existing answers from:</p>
                <label>Conservation Action</label>
                <ConservationActionFieldEditor
                    Value={targetConservationActionId}
                    OnUpdate={(conservationActionId) => {
                        setConservationActionId(conservationActionId);
                    }}
                    // this restricts ConservationAction search to CAs of the same type
                    CustomData={{
                        filter: function(values, selectedItem) {
                            return values.filter(x => x.conservationActionTypeId == targetConservationActionTypeId);
                        }
                    }}
                />
                <br/>
                <label>Survey</label>
                <FormControl
                    as="select"
                    value={surveyTypeId}
                    onChange={(e) => {
                        setSurveyTypeId(e.target.value);
                    }}
                >
                    <option value={''}>Select a Survey</option>
                    {
                        surveyTypes.map(x => (
                            <option key={x.surveyTypeId} value={x.surveyTypeId}>
                                {x.name}
                            </option>
                        ))}
                </FormControl>
            </div>
            <br key={2}/>
            <div key={3} className="text-danger font-weight-bold">Warning: Existing data on the current page will be overwritten.</div>
        </ConfirmationDialog>
    );
}


